module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "admin-portal-users-container"
  }, [_c('div', [_c('admin-portal-users-top-bar', {
    attrs: {
      "licenseDetails": _vm.licenseDetails,
      "licensesUsed": _vm.licensesUsed
    }
  })], 1), _vm._v(" "), (_vm.emailSuffixes && _vm.emailSuffixes.length) ? _c('div', {
    staticClass: "pl-subheading mb3"
  }, [_vm._v("\n    Approved email suffixes:\n    "), _vm._l((_vm.emailSuffixes), function(email_suffix, index) {
    return _c('span', [_vm._v("\n      " + _vm._s(index + 1 !== _vm.emailSuffixes.length ?
      email_suffix + ', ' :
      email_suffix) + "\n    ")])
  })], 2) : _vm._e(), _vm._v(" "), _c('div', [_c('admin-portal-users-filters-bar', {
    attrs: {
      "schoolSites": _vm.school_sites
    },
    on: {
      "parlay-users-filter-changed": _vm.resetFilters,
      "filters": _vm.searchAndFilters,
      "getTrialTeachers": _vm.showTrialTeachers,
      "getUsers": _vm.showUsers
    }
  })], 1), _vm._v(" "), _c('div', [_c('admin-portal-users-table', {
    attrs: {
      "loading": _vm.loading,
      "usersList": _vm.usersList,
      "schoolUsersCount": _vm.schoolUsersCount,
      "schoolUsersCountLoaded": _vm.schoolUsersCountLoaded,
      "trialTeachers": _vm.trialTeachers,
      "schoolSites": _vm.school_sites
    },
    on: {
      "scroll-on-table": function($event) {
        return _vm.handleScroll(_vm.page_number)
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row w-100 center-xs"
  }, [(_vm.loading_table_body) ? _c('div', [_c('pl-spinner', {
    staticClass: "x5"
  })], 1) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-4bfa24c5!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/features/admin/adminPortal/adminPortalUsers/adminPortalUsers.vue
// module id = 2058
// module chunks = 61